let currentHistory;

export default {
  get() {
    if (!currentHistory) {
      throw new Error('Tried to get history, but there is no history!');
    }
    return currentHistory;
  },

  set(store) {
    currentHistory = store;
  },
};
